import React from 'react';
import { FieldProps, useFormikContext } from 'formik';
import { InputNumber, InputNumberProps } from 'rsuite5';
import _ from 'lodash';
import options from '@/utils/options';

/**
 * inputNumber输入的数字类型
 */
export type NumType = 'int';

export interface InputNumberFieldProps extends InputNumberProps, Partial<Omit<FieldProps, 'form'>> {
  controls?: boolean;
  /**
   * 输入的数字类型 默认int整数
   */
  numType?: NumType;
  /**
   * 最大值
   */
  max?: number;
  /**
   * 最小值
   */
  min?: number;
}

function InputNumberField({
  field,
  controls = false,
  numType = 'int',
  max = Infinity,
  min = -Infinity,
  ...props
}: InputNumberFieldProps) {
  const formik = useFormikContext();
  return (
    <InputNumber
      className={`formik-input-number ${!controls ? 'hide-controls' : ''}`}
      name={field.name}
      value={field.value}
      onChange={(value) => {
        field.onChange?.(value);
        formik.setFieldValue(field.name, value === '' ? '' : Number(value));
      }}
      onBlur={() => {
        if (field.value !== '') {
          const value = Number(field.value);
          const shouldValue = options(
            {
              int: () => {
                if (_.isNaN(value)) {
                  return min;
                } else if (value >= min && value <= max) {
                  return Math.round(value);
                } else {
                  return value < min ? min : max;
                }
              },
              default: () => value,
            },
            numType
          );
          formik.setFieldValue(field.name, shouldValue);
        }
      }}
      {...props}
    />
  );
}

export default InputNumberField;
